<template>
  <div class="cert-list-empty">
    <img
      class="cert-list-empty-img"
      src="@/assets/images/profile/empty_state_cert.png"
    />
    <h6 class="dashboard__tab-title cert-list-empty__title">
      You don't have any Certifications yet
    </h6>
    <p class="cert-list-empty__info">
      IT certifications are widely recognized by hiring managers and
      organizations worldwide and can help showcase your skills as you
      accelerate or kickstart your career. <br />
      <br />
      Certification holders can now earn
      <a :href="linkToCPEProgram" target="_blank">
        CPE credits
      </a>
      for completing training, which can be applied toward certification
      renewals.
    </p>
    <div class="cert-list-empty__btn-wrapper">
      <a
        :href="linkToCPEProgram"
        target="_blank"
        class="btn btn--secondary btn--small"
      >
        CPE Program
      </a>
      <router-link
        :to="{ name: 'certifications' }"
        class="btn btn--primary btn--small"
      >
        INE Certifications
      </router-link>
    </div>
  </div>
</template>

<script>
import CONSTANTS from '@/constants'

const {
  CPE: { LINK_TO_CPE_PROGRAM },
} = CONSTANTS

export default {
  name: 'CertificationsListEmpty',
  data() {
    return {
      linkToCPEProgram: LINK_TO_CPE_PROGRAM,
    }
  },
}
</script>

<style lang="scss">
.cert-list-empty {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: var(--white);
  text-align: center;
  @include desktop {
    max-width: 900px;
  }
  &__title {
    text-align: center;
    margin: 0 0 10px 0 !important;
  }
  &__info {
    text-align: center;
    font-size: 1rem;
    font-style: normal;
    font-weight: 450;
    line-height: 1.5rem;
    color: var(--light-blue-gray);

    a {
      color: var(--purple-pale);
      cursor: pointer;

      &:hover {
        text-decoration: underline;
      }
    }
  }
  &__btn-wrapper {
    margin: 10px auto 0;

    display: flex;
    gap: 10px;
  }
  &-img {
    width: 100%;
    max-height: 315px;
    object-fit: contain;
    @include tablet {
      width: unset;
    }
  }
}
</style>
